export const capitalize = (string) => {
  if (string && string.length)
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  else return "";
};

export function isFloat(n) {
  return Number(n) === n && n % 1 !== 0;
}